<template>
  <el-table
    :data="tableData"
    border
    style="width: 100%"
    :maxHeight="maxHeight"
    :span-method="objectSpanMethod"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      prop="changeTypeName"
      label="变更类型"
      min-width="140"
      align="center"
    />
    <el-table-column
      prop="detailTypeName"
      label="来源明细"
      min-width="160"
      align="center"
    />
    <el-table-column
      prop="score"
      label="积分"
      min-width="120"
      align="center"
      sortable
    />
    <el-table-column
      prop="memberCount"
      label="人数"
      min-width="120"
      align="right"
      sortable
    />
    <el-table-column
      prop="scoreRatio"
      label="积分数占比"
      min-width="120"
      align="right"
      sortable
    />
    <el-table-column
      prop="memberRatio"
      label="人数占比"
      min-width="120"
      align="right"
      sortable
    />
  </el-table>
</template>

<script>
import mixins from "../../mixins/index.js";
import Empty from "../../components/empty.vue";
export default {
  name: "pointsChangeAnalysis",
  mixins: [mixins],
  components: {
    Empty,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
  },
  computed: {
    countTable() {
      return this.tableData.map((row) => {
        const newRow = {};
        Object.keys(row).forEach((key) => {
          // 不需要处理得字段直接返回
          if (key === "detailTypeName" || key === "changeTypeName") {
            newRow[key] = row[key];
            return;
          }
          // Ratio 字段 → 百分比
          if (key.includes("Ratio")) {
            newRow[key] = this.formatPercent(row[key]);
          } else {
            // 其他数值 → 普通数字
            newRow[key] = this.formatNumber(row[key]);
          }
        });
        return newRow;
      });
    },
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 只处理第一列（changeType）
      if (columnIndex !== 0) return;
      const currentType = row.changeTypeName;
      // 空的 changeType（即子项）不显示
      if (!currentType) {
        return { rowspan: 0, colspan: 0 };
      }
      // 统计相同 changeTypeName 的连续行数
      let rowspan = 1;
      for (let i = rowIndex + 1; i < this.countTable.length; i++) {
        if (this.countTable[i].changeTypeName === currentType) {
          rowspan++;
        } else {
          break;
        }
      }
      // 如果上一个行的类型也是一样的 → 不显示（避免重复合并）
      if (
        rowIndex > 0 &&
        this.countTable[rowIndex - 1].changeTypeName === currentType
      ) {
        return { rowspan: 0, colspan: 0 };
      }
      return {
        rowspan,
        colspan: 1,
      };
    },
  },
};
</script>
